/* istanbul ignore file */
import logger from '../../log';
import KernelModule from 'ksdk-wasmkernel';

const log = logger.getLogger(__filename);

/**
 * Fetch the kernel module object.
 *
 * @param {!string} binaryUrl url location of the wasm binary.
 * @returns {Promise} promise containing config data or error
 */
export default async function getKernelModule(binaryUrl) {
  // returns a promise that will resolve when binary is loaded
  // Source the js runtime file inline
  if (!binaryUrl) {
    log.error('No valid path to js wasm runtime');
    return Promise.reject();
  }
  return new Promise((resolve, reject) => {
    // https://emscripten.org/docs/api_reference/module.html#affecting-execution
    try {
      const runtimeOptions = {
        onAbort: function (what) {
          log.error('Kernel module aborting', what);
          reject();
        },
        printErr: function (err) {
          log.error('Error reported by wasm kernel module:', err);
        },
        print: function (what) {
          log.debug('Reported by wasm kernel module:', what);
        },
        locateFile: () => binaryUrl
      };
      KernelModule(runtimeOptions)
        .then(kernelModule => {
          log.trace('Runtime is initialized');
          // Need to delete this to avoid an infinite loop. The emscripten js runtime exports a 'then' method that is not
          // actually a promise. The then will be continuously invoked by resolve.
          delete kernelModule.then;
          resolve(kernelModule);
        })
        .catch(e => reject(e));
    } catch (e) {
      // The KernelModule instantiation (via emscripten) may not provide a true Promise and can leak the exception
      reject(e);
    }
  });
}
